














































import Vue from 'vue';
import he from 'he';
import { BMedia, BImgLazy, BLink } from 'bootstrap-vue';
import InfiniteLoading from 'vue-infinite-loading';
import { Comment } from '../common/types';

export default Vue.extend({
  name: 'comments-item',
  data: () => ({
    showChildren: false,
    children: [] as Comment[],
    hasNext: true,
  }),
  computed: {
    refCommentId(): string {
      if (!this.children.length) {
        return '';
      }
      return this.children[this.children.length - 1]!.commentId;
    },
  },
  props: ['comment', 'postId', 'orderScore'],
  methods: {
    getChildren() {
      const query = new URLSearchParams(
        'appId=a_dd8f2b7d304a10edaf6f29517ea0ca4100a43d1b&count=10',
      );
      query.set('url', 'http://9gag.com/gag/' + this.postId);
      query.set('order', this.orderScore ? 'score' : 'ts');
      query.set('refCommentId', this.refCommentId);
      return fetch(
        '/comment.php/v1/cacheable/comment-list.json?' + query.toString(),
      )
        .then((res) => res.json())
        .then((res) => {
          this.children = this.children.concat(res.payload.comments);
          this.hasNext = res.payload.hasNext;
        });
    },
    infiniteHandler($state: any) {
      if (!this.hasNext) {
        return $state.complete();
      }
      this.getChildren()
        .then(() => $state.loaded())
        .catch($state.error);
    },
    htmlDecode(str: string) {
      return he.decode(str);
    },
  },
  created() {
    this.children = this.comment.children;
  },
  components: { BMedia, BImgLazy, BLink, InfiniteLoading },
});
